import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Enquiry routes
const Lead = Loader(
  lazy(
    () => import('src/components/lead-management/view-lead/customer-wise-lead')
  )
);

const ViewLead = Loader(
  lazy(() => import('src/components/lead-management/customer-view/index'))
);

const enquiryRoutesVendor = [
  {
    path: '',
    element: <Navigate to="customer-lead" replace />
  },
  {
    path: 'view-lead',
    children: [
      {
        path: 'customer-lead',
        element: <Lead />
      },
      {
        path: 'customer-lead-details',
        element: <ViewLead />
      }
    ]
  }
];

export default enquiryRoutesVendor;
